import React from "react";
import { GetStaticProps } from "next";
import { MetaDataPage, MetaDataPageType } from "src/models/meta/getMetaData";
import MetaContainer from "src/components/common/Layout/components/MetaContainer/MetaContainer";
import NewProductPage from "src/components/NewProductPage/NewProductPage";
import { requestNewProductPage } from "src/utils/helpers/requestApi/serverFetchPage/requestNewProductPage";
import { NewCatalogProductSchema } from "src/models/newProduct/getNewProduct";

interface ProductProps {
  productData: NewCatalogProductSchema;
}

const Product: React.FC<ProductProps & MetaDataPage> = ({
  productData,
  ...metaData
}) => {
  return (
    <MetaContainer {...metaData}>
      <NewProductPage productData={productData} />
    </MetaContainer>
  );
};

export const getStaticPaths = async () => {
  return {
    paths: [
      {
        params: {
          city: "moskva",
          product: "kagotsel-r-niarmedik-farma-tabletki-12-mg-10",
        },
      },
    ],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = requestNewProductPage.bind(
  null,
  MetaDataPageType.catalogProduct
);

export default Product;
